/** A tool call's result as CopilotKit keeps it (a JSON string), parsed; undefined when absent or not JSON (e.g. a
 * retry message the agent got instead of data). */
export function parseToolResult<T>(result?: string): T | undefined {
  if (!result) return undefined;
  try {
    return JSON.parse(result) as T;
  } catch {
    return undefined;
  }
}
